import React from 'react'

import type { WebProps } from './types'

const Switch = (props: WebProps) => {
  return (
    <button
      className="group relative inline-flex h-6 w-11 disabled:opacity-30"
      role="switch"
      type="button"
      aria-checked={props.value}
      disabled={props.disabled}
      tabIndex={0}
      onClick={async () => props.onValueChange?.(!props.value)}
      onKeyUp={async () => props.onValueChange?.(!props.value)}
      id={props.id}
    >
      <span className="relative h-full w-full items-center justify-start rounded-full bg-ui-grey-500 px-0.5 transition duration-300 group-aria-checked:bg-brand-dark">
        <span className="absolute left-0.5 top-0.5 h-5 w-5 rounded-full bg-ui-light transition-all duration-300 group-aria-checked:-left-0.5 group-aria-checked:translate-x-6" />
      </span>
      <span className="sr-only">{props.label}</span>
    </button>
  )
}

export default Switch
